import { shallowMount } from "@vue/test-utils";
import OfertaCA from "@/views/OfertaCA";

describe("OfertaCA component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(OfertaCA);
  });

  it("Renders del component OfertaCA", () => {
    expect(wrapper).toBeDefined();
  });
});
